import {
  Button,
  CircularProgress,
  DialogContent,
  Grid,
} from '@material-ui/core';
import { hideModal } from 'Core/ducks/modal';
import { Empty, isLoaded } from 'Core/models/Async';
import React, { useEffect }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import Modal from 'Shared/components/Modal';
import { changeMarketingFormStates } from '../ducks/marketingFormState';
import { MarketingFormStateDto } from '../models/Marketing';
  
type MarketingFormStatesProps = {
  states: MarketingFormStateDto;
  hideModal: () => void;
};

const MarketingFormStatesModel = (props: MarketingFormStatesProps) => {

  const dispatch = useDispatch();
  
  const response = useSelector((state: ReducerState) => state.marketingFormState);

  useEffect(() => {
    return () => {
      dispatch(changeMarketingFormStates(new Empty()));
    };
  }, [dispatch]);

  return (
    <Modal title="States" open onClose={() => dispatch(hideModal())}>
      <DialogContent className="mf-states-modal__dialogPaper">
        <Grid container direction="column" alignItems="center">
          {response && isLoaded(response)? (
              <div className="mf-states-modal">
                <div className="mf-states-modal__statesBody" key={`mf-states-modal-states`}>
                  <p>
                    {response.Data.join(', ')}
                  </p>
                </div>
                <div className="mf-states-modal__closeButton" key={`mf-states-modal-states`}>
                  <Button onClick={props.hideModal} fullWidth variant="contained" color="primary">
                    Close
                  </Button>
                </div>
              </div>
          ) : (
            <CircularProgress color="primary" />
          )}
        </Grid>
      </DialogContent>
    </Modal>
  );
};

export default MarketingFormStatesModel;
